const baseRoutes = require('./baseRoutes');
const { routeDebug: debug } = require('../util/debuggers');
/** ---------- Hilfsfunktionen ---------- */
function addExtensions(children, extensions) {
  if (!extensions) {
    return children;
  }

  const extensionRoutes = baseRoutes.filter((baseRoute) => {
    return extensions.includes(baseRoute.name);
  });
  return [
    ...extensionRoutes.map((extensionRoute) => {
      const componentName = extensionRoute.component;
      extensionRoute.component = () =>
        import(`@user/views/Default/Routes/${componentName}`);
      return extensionRoute;
    }),
    ...children,
  ];
}

function excludeRoutes(children, exclude) {
  if (!exclude) {
    return children;
  }
  const newChildRoutes = children.filter((child) => {
    if (exclude.includes(child.name) || exclude.includes(child.path)) {
      return false;
    }
    return true;
  });
  return newChildRoutes;
}

/** ---------- Hauptfunktion ---------- */
export function buildRoutes(projectParam, routes, extensions, exclude) {
  const noExistingProject = projectParam.length === 0;
  const path = noExistingProject ? '' : `/${projectParam}`;

  const pageNotFound = {
    path: `${path}/page-not-found`,
    name: 'PageNotFound',
    component: () =>
      import(
        /* webpackChunkName: "PageNotFound" */
        '@user/views/Default/Routes/PageNotFound'
      ),
    props: {
      noProject: noExistingProject,
    },
  };
  const catchAll = {
    path: `${path}/*`,
    redirect: `${path}/page-not-found`,
  };

  if (projectParam.length === 0) return [pageNotFound, catchAll];
  const projectRoutes = routes.find((entryRoute) => {
    // Finde richtige Routen für Projekt
    return entryRoute.path.includes(projectParam)
      ? entryRoute.path.includes(projectParam)
      : entryRoute.path === '/:name';
  });
  const defaultRoutes = projectRoutes.children;
  debug('defaultRoutes %o', defaultRoutes);
  // Kindrouten (Extensions & Excludes) behandeln
  const extendedRoutes = addExtensions(defaultRoutes, extensions);
  const filteredRoutes = excludeRoutes(extendedRoutes, exclude);
  debug('routes after extension and exclude %o', filteredRoutes);

  projectRoutes.children = filteredRoutes;
  return [projectRoutes, pageNotFound, catchAll];
}
